import React, { FunctionComponent, useState } from "react";
import { Link } from "react-router-dom";
// Context
import { useCart } from "../../../../../context/CartContext";

import ButtonComponent from "../../../../ButtonComponent";
import TaxDisclaimerComponent from "./TaxDisclaimerComponent";
import SummaryTableComponent from "./SummaryTableComponent";

import "./SummaryCard.scss";
import QuantityDisclaimerComponente from "./QuantityDisclaimerComponente";
import classNames from "classnames";
import useModal from "../../../../../utils/hooks/useModal";
import ClearCartModal from "../../Detail/CartDetailComponent/CartDetailSection/ClearCartModal";
import { clearAllBodyScrollLocks } from "body-scroll-lock";

const SummaryCardComponent: FunctionComponent = () => {
  const { cart } = useCart();

  const { isOpen, toggle } = useModal();

  const [modalType, setModalType] = useState<"clear" | null>(null);

  const handleClearCart = () => {
    setModalType("clear");
    toggle();
  };

  const handleCloseModal = () => {
    clearAllBodyScrollLocks();
    toggle();
  };

  const cartEnabled =
    cart &&
    (((cart?.summary.by_material.gold.quantity >= 5 ||
      (cart?.summary.by_material.gold.quantity == 0 &&
        cart?.summary.by_material.silver.quantity > 0) ||
      cart?.summary.by_material.silver.quantity >= 12) &&
      (cart?.summary.by_material.silver.quantity >= 12 ||
        (cart?.summary.by_material.silver.quantity == 0 &&
          cart?.summary.by_material.gold.quantity > 0))) ||
      cart?.summary.by_material.gold.quantity >= 5);

  return (
    <main className="summary__card">
      <h2 className="summary__card__header">Resumen</h2>
      <section className="summary__card__content">
        {modalType === "clear" && (
          <ClearCartModal isOpen={isOpen} onClose={handleCloseModal} />
        )}
        {cart ? <SummaryTableComponent cart={cart} /> : null}

        <TaxDisclaimerComponent />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {/** TO DO move this to the Button adding a modifier for --gold */}
          {cart && cartEnabled ? (
            <Link to="/checkout" style={{ width: "100%" }}>
              <ButtonComponent onClick={() => {}}>
                Realizar Pedido
              </ButtonComponent>
            </Link>
          ) : (
            <>
              <QuantityDisclaimerComponente />
                <ButtonComponent modifier="disabled" onClick={() => {}}>
                  Realizar Pedido
                </ButtonComponent>
              <Link to="/" style={{ width: "100%" }}>
                <button type="button" className={classNames("button__white")}>
                  Seguir comprando
                </button>
              </Link>
            </>
          )}
          <span onClick={handleClearCart} className="clean_cart">
            Limpiar carrito
          </span>
        </div>
      </section>
    </main>
  );
};

export default SummaryCardComponent;
